import { jsx, jsxs } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var sides_vertical_default = /* @__PURE__ */ jsxs(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: [
  /* @__PURE__ */ jsx(
    Path,
    {
      d: "m7.5 6h9v-1.5h-9zm0 13.5h9v-1.5h-9zm-3-3h1.5v-9h-1.5zm13.5-9v9h1.5v-9z",
      style: { opacity: 0.25 }
    }
  ),
  /* @__PURE__ */ jsx(Path, { d: "m7.5 6h9v-1.5h-9z" }),
  /* @__PURE__ */ jsx(Path, { d: "m7.5 19.5h9v-1.5h-9z" })
] });
export {
  sides_vertical_default as default
};
//# sourceMappingURL=sides-vertical.js.map
